import React from "react";
import { cn } from "../../lib/utils";

export function PageToolbar({
  filters,
  actions,
  children,
  className,
  sticky = false,
  scrollActions = true,
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 rounded-xl border border-transparent sm:flex-row sm:items-center sm:justify-between",
        sticky &&
          "sticky top-16 z-20 border-[#242E42] bg-[#0B0E14]/90 p-3 backdrop-blur",
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:items-center">
        {filters || children}
      </div>
      {actions ? (
        <div
          className={cn(
            "flex shrink-0 items-center gap-2",
            scrollActions
              ? "-mx-1 overflow-x-auto px-1 pb-1 sm:mx-0 sm:flex-wrap sm:justify-end sm:overflow-visible sm:px-0 sm:pb-0"
              : "flex-wrap sm:justify-end",
          )}
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}

export default PageToolbar;
